export const GRAPHQL_URL = "https://www.rodeo.bg:2041/graphql";